import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Reusable editor for a list of string values, rendered as removable chips with an
 * add input. Two-way bindable via [(items)].
 */
@Component({
  selector: 'app-string-list-editor',
  templateUrl: './string-list-editor.component.html',
  styleUrl: './string-list-editor.component.scss'
})
export class StringListEditorComponent {
  @Input() items: string[] = [];
  @Input() placeholder = 'Add value';
  @Input() disabled = false;
  @Output() itemsChange = new EventEmitter<string[]>();

  newValue = '';

  add() {
    const value = (this.newValue || '').trim();
    if (!value) return;
    // Case-insensitive de-dup so the same key isn't added twice.
    if (!this.items.some(i => i.toLowerCase() === value.toLowerCase())) {
      this.items = [...this.items, value];
      this.itemsChange.emit(this.items);
    }
    this.newValue = '';
  }

  remove(item: string) {
    this.items = this.items.filter(i => i !== item);
    this.itemsChange.emit(this.items);
  }
}
